import { Modal, NavigationTabs } from '@chocolate-soup-inc/cs-frontend-components';
import { ReactNode, useCallback } from 'react';
import { generatePath, useNavigate, useParams } from 'react-router-dom';
import { useQueryListOneCompany } from '../../entities/companies/queries';
import { DETAILS_PATH, GIFT_PACKAGES_PATH, USERS_PATH } from '../../routes/paths';

export type TCompanyModalProps = {
  children: ReactNode;
  headline?: string;
};

export const CompanyModal = (props: TCompanyModalProps) => {
  const { children, headline } = props;
  const navigate = useNavigate();
  const { companyId = '0' } = useParams();

  const closeModal = useCallback(() => {
    navigate(generatePath('../../'));
  }, [navigate]);

  const { data: company } = useQueryListOneCompany({
    id: companyId
  });

  return (
    <Modal closeModal={closeModal} headline={headline} open={true} size='large'>
      <NavigationTabs
        options={[
          {
            leadingIcon: 'info',
            label: 'Details',
            path: generatePath(`../${DETAILS_PATH}`, {
              companyId
            })
          },
          {
            disabled: !company?.fullyConfigured,
            leadingIcon: 'group',
            label: 'Users',
            path: generatePath(`../${USERS_PATH}`, {
              companyId
            })
          },
          {
            disabled: !company?.fullyConfigured,
            leadingIcon: 'card_giftcard',
            label: 'Custom Gift Packages',
            path: generatePath(`../${GIFT_PACKAGES_PATH}`, {
              companyId
            })
          }
        ]}
      />
      <div>{children}</div>
    </Modal>
  );
};
